import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { addUser, clearError } from "./store/userDataSlice";
import api from "../../../api";
import { toast } from "react-toastify";

const AddUserDataModal = ({ show, onClose, userId }) => {
  const dispatch = useDispatch();
  const { addLoading, error, data } = useSelector((state) => state.userData);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await api.post("/role");
        const roles = response.data.data.map((role) => ({
          value: role.id,
          label: role.name,
        }));
        setRoleOptions(roles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  useEffect(() => {
    if (userId && roleOptions.length > 0) {
      const user = data.find((user) => user.id === userId);
      console.log(user)
      if (user) {
        setName(user.name);
        setEmail(user.email);
        setPhone(user.phone || "");
        console.log(roleOptions.find((role) => role.value === user.role.id))
        console.log(roleOptions)
        // Set the selected role based on the user's role_id
        setRole(roleOptions.find((role) => role.value === user.role.id));
      }
    }
  }, [userId, data, roleOptions]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      id: userId,
      name,
      email,
      phone,
      role_id: role?.value,
    };

    const result = await dispatch(addUser(userData));
    if (addUser.fulfilled.match(result)) {
      toast.success(
        userId ? "User updated successfully!" : "User added successfully!"
      );
      onClose();
    } else if (addUser.rejected.match(result)) {
      toast.error(
        result.payload?.message || "Failed to add user. Please try again."
      );
    }
  };

  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
      setPhone("");
      setRole(null);
      dispatch(clearError());
    }
  }, [show, dispatch]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>{userId ? "Edit User" : "Add User"}</Modal.Title>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            right: "1rem",
            top: "0rem",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            color: "#000",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              // required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Select
              placeholder="Select Role"
              value={role}
              onChange={setRole}
              options={roleOptions}
              required
            />
          </Form.Group>
          <Form.Group className="text-end mt-4">
            <Button variant="primary" type="submit" disabled={addLoading}>
              {addLoading ? (
                <Spinner as="span" animation="border" size="sm" />
              ) : userId ? (
                "Update"
              ) : (
                "Submit"
              )}
            </Button>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddUserDataModal;
